import React, { useState } from "react";
import axios from "axios";
import config from "../../config";
import { toast } from "react-toastify";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import InnerHeader from "../common/InnerHeader";
import Footer from "../common/Footer";
import "../homepage/Style/testimonial.css";

const TestimonialForm = () => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const [formData, setFormData] = useState({
    name: "",
    rating: "",
    country: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const rawContent = JSON.stringify(convertToRaw(editorState.getCurrentContent()));

    if (!formData.name || !formData.rating || !formData.country) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      await axios.post(`${config.baseUrl}/add-testimonial`, {
        ...formData,
        description: rawContent,
      });

      toast.success("Thank you for your testimonial!");
      setFormData({ name: "", rating: "", country: "" });
      setEditorState(EditorState.createEmpty());
    } catch {
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <InnerHeader />

      <div className="reviewPage">
        <div className="container">
          <div className="testimonialCard">

            <div className="reviewTabs">
              <a href="/reviews" className="btn btn-light">READ REVIEWS</a>
              <button className="btn btn-orange">WRITE A REVIEW</button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label>Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label>Your Rating *</label>
                  <select
                    className="form-control"
                    name="rating"
                    value={formData.rating}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    {[1, 2, 3, 4, 5].map(r => (
                      <option key={r} value={r}>{r}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-3">
                <label>Country *</label>
                <input
                  className="form-control"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                />
              </div>

              <label>Comments *</label>
              <div className="testimonialEditor">
                <Editor
                  editorState={editorState}
                  onEditorStateChange={setEditorState}
                  toolbarHidden
                  editorStyle={{ minHeight: 140, padding: 15 }}
                />
              </div>

              <button type="submit" className="submitReviewBtn mt-4">
                Submit Review
              </button>
            </form>

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default TestimonialForm;
